import styled from 'styled-components'

const PreloaderStyle = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 112;
	overflow: hidden;
	background-color: var(--black);

	.LottieWrap {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 18%;
		height: auto;
		transform: translate(-50%, -50%);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.LottieWrap {
			width: 30%;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.LottieWrap {
			width: 50%;
		}
	}
`

export default PreloaderStyle
